import React from 'react';
import { completedTaskIdsForDate, reminderTaskProgress, reminderTasks } from './reminderUtils';

const ReminderTaskChecklist = ({
  reminder,
  dateStr,
  onToggleTask,
  disabled = false,
}) => {
  const tasks = reminderTasks(reminder);
  if (!tasks.length) return null;
  const doneIds = new Set(completedTaskIdsForDate(reminder, dateStr));
  const progress = reminderTaskProgress(reminder, dateStr);

  return (
    <div className="space-y-2">
      {progress ? (
        <p className="text-[11px] font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400">
          Tasks · {progress.done}/{progress.total} · {progress.percent}%
        </p>
      ) : (
        <p className="text-[11px] font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400">
          Tasks
        </p>
      )}
      <ul className="space-y-1.5">
        {tasks.map((task) => {
          const checked = Boolean(task.id && doneIds.has(task.id));
          return (
            <li key={task.id || task.title}>
              <label
                className={`flex items-start gap-2.5 rounded-xl border px-3 py-2 cursor-pointer transition-colors ${
                  checked
                    ? 'border-emerald-300 bg-emerald-50 text-emerald-900 dark:border-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-100'
                    : 'border-slate-200 bg-white text-gray-800 dark:border-gray-700 dark:bg-gray-800/70 dark:text-gray-100'
                } ${disabled ? 'opacity-70 cursor-default' : ''}`}
              >
                <input
                  type="checkbox"
                  className="mt-0.5 rounded border-gray-300 text-emerald-600 focus:ring-emerald-500"
                  checked={checked}
                  disabled={disabled || !onToggleTask}
                  onChange={(e) => {
                    e.stopPropagation();
                    if (!disabled && onToggleTask) onToggleTask(task);
                  }}
                  onClick={(e) => e.stopPropagation()}
                />
                <span className={`text-sm font-medium leading-snug ${checked ? 'line-through decoration-emerald-600/70' : ''}`}>
                  {task.title || 'Task'}
                </span>
              </label>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default ReminderTaskChecklist;
